import {Component, Input, NgModule} from '@angular/core';
import {DataService} from 'shared/_services/data.service';
import {selectUrlToGetFile} from '../../../../_selectors/journal.selectors';
import {Store} from '@ngrx/store';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IHistoricValue} from '../../../../_interface/ientry-field-for-show';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@ngneat/transloco';
import {EllipsisModule} from 'shared/lib/ellipsis/ellipsis.component';
import {IconSpritesModule} from 'shared/lib/icon-sprite/icon-sprite.component';

@UntilDestroy()
@Component({
	selector: 'journal-content-render',
	templateUrl: './content-render.component.html',
	styleUrls: ['./content-render.component.scss']
})
export class ContentRenderComponent {
	@Input() key: keyof IHistoricValue;
	@Input() value: any;
	@Input() content: IHistoricValue;
	@Input() active = false;
	@Input() index: number;

	pre: string;

	constructor(
		private data: DataService,
		private store: Store
	) {
		this.store.select(selectUrlToGetFile).pipe(
			untilDestroyed(this)
		).subscribe(endpoint => this.pre = endpoint);
	}
	isArray = (items: any) => Array.isArray(items);

	downloadFile(id: any, name: string) {
		const url = `${this.pre}/${id}`;
		this.data.downloadFile(url, name).pipe(
			untilDestroyed(this)
		).subscribe(() => {});
	}
}

@NgModule({
	declarations: [ContentRenderComponent],
	imports: [
		CommonModule,
		TranslocoModule,
		EllipsisModule,
		IconSpritesModule
	],
	exports: [ContentRenderComponent]
})
export class ContentRenderModule {}
